
$(document).on('ready markupLoaded', () => {
	const $element = $("[data-videoblock]");

	if ($element && $element.length > 0) {
		System.import(
			/* webpackChunkName: "components/video-block" */
			'./component.js').then(({ videoBlock }) => {
				$element.each((index, element) => {
					new videoBlock(element);
				});
			});
	}
});


// WEBPACK FOOTER //
// ./client/src/site__fus078/components/blocks/video/index.js